export default __webpack_public_path__ + "static/media/HeroHeader.443df028.jpeg";